import { HelperFunctions } from 'helpers';

// The state shape shared by every topic whose step lets the manager correct the record it
// presents. The Wizard renders only its active step, so a step unmounts as soon as the manager
// moves on - the record, any in-progress edit and the topic comment therefore live in the
// page's topic state rather than inside the step.
export function createEditableTopicState() {
    return {
        record: null,
        draft: null,
        editing: false,
        saving: false,
        comment: "",
        loadFailed: false,
        refreshFailed: false
    };
}

export function hasDraftChanges(state) {
    return !HelperFunctions.deepEqual(state?.record, state?.draft);
}

// The completed review's snapshot is rebuilt from the persisted record at completion time, so a
// topic left mid-edit or holding unsaved changes would be frozen without them. A topic whose
// record could not be read cannot be reviewed at all.
export function getEditableTopicGating(state, subject, loadFailureTooltip) {
    if (state?.loadFailed === true) {
        return { canProceed: false, cantProceedTooltip: loadFailureTooltip };
    }

    const canProceed = state?.editing !== true && state?.saving !== true && !hasDraftChanges(state);

    return {
        canProceed,
        cantProceedTooltip: canProceed ? null : `Save or cancel your ${subject} changes before continuing.`
    };
}

// Everything the manager would lose by leaving the page: an unsaved correction to the record, or
// a comment typed against the topic.
export function isEditableTopicDirty(state) {
    return hasDraftChanges(state) || (state?.comment ?? "") !== "";
}

// Applied to a loaded record: the draft edits start from a separate copy so the stored record
// stays intact until a save lands.
export function applyLoadedRecord(record) {
    return {
        record,
        draft: HelperFunctions.deepClone(record)
    };
}
